import { render, staticRenderFns } from "./RestrictedProposalFillPage.vue?vue&type=template&id=95b4320a&scoped=true"
import script from "./RestrictedProposalFillPage.vue?vue&type=script&lang=js"
export * from "./RestrictedProposalFillPage.vue?vue&type=script&lang=js"
import style0 from "./RestrictedProposalFillPage.vue?vue&type=style&index=0&id=95b4320a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b4320a",
  null
  
)

export default component.exports